import { createApp } from 'vue'
import App from './App.vue'
import 'vant/es/toast/style';
import router from "./router/index";
import { Lazyload } from 'vant';
// 引入国际化文件
import i18n from './i18n/index';
const app = createApp(App);
app.use(router);
app.use(Lazyload);
app.use(i18n);
app.mount('#app');
